// Navigation store — mode atual, sub-tab por modo, modos visitados
import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";

export const useNavigationStore = create(persist(
  (set, get) => ({
    mode: null,                                       // null = home, "audit" | "tools" | "academia" | "explorer"
    tabs: { audit: "dashboard", tools: "cenario", academia: "journey", explorer: "search" },
    visited: [],                                      // Array (not Set — JSON serializable)

    setMode: (mode) => set({ mode }),

    setTab: (mode, tab) => set((s) => ({ tabs: { ...s.tabs, [mode]: tab } })),

    goMode: (mode, defaultTab) => {
      const { visited, tabs } = get();
      if (defaultTab && !visited.includes(mode)) {
        set({ tabs: { ...tabs, [mode]: defaultTab }, visited: [...visited, mode], mode });
      } else {
        set({ mode });
      }
    },

    goHome: () => set({ mode: null }),
  }),
  {
    name: "norm_navigation",
    storage: createJSONStorage(() => localStorage),
  }
));
